<div class="page-content-wrapper">
  <app-sidebar-layout [showMenuToggle]="true">
    <section class="card-style-sec samples-sec p-20">
      <div class="container-fluid">
        <div class="card-main-title">
          <app-tab-main [links]="tabs"></app-tab-main>
          <button mat-raised-button class="add-role-btn" (click)="addRole()">
            <span class="add-role-text"><i class="fa fa-plus add-role-text"></i> {{'Add Role' | translate}}</span>
          </button>
        </div>

        <mat-accordion [multi]="true">
          @for (role of roles; track trackById($index, role)) {
            <mat-expansion-panel [expanded]="isEditingRole[role.id]">
              <mat-expansion-panel-header>
                <mat-panel-title (click)="$event.stopPropagation()">
                  @if (!isEditingRole[role.id]) {
                    {{ role.name | translate}}
                  }
                  @if (isEditingRole[role.id]) {
                    <mat-form-field>
                      <input matInput class="input-area" placeholder="{{'Role Name' | translate}}" [(ngModel)]="role.name" (keydown)="$event.stopPropagation()">
                    </mat-form-field>
                  }
                </mat-panel-title>
                <mat-panel-description>
                  @if (!isEditingRole[role.id]) {
                    {{ role.description | translate}}
                  }
                  @if (isEditingRole[role.id]) {
                    <mat-form-field class="description-field">
                      <input matInput [placeholder]="'Description' | translate" [(ngModel)]="role.description" (keydown)="$event.stopPropagation()"
                        (click)="$event.stopPropagation()" class="description-textarea input-area" />
                      </mat-form-field>
                    }
                  </mat-panel-description>
                  @if (isEditingRole[role.id] && !role.id) {
                    <div (click)="$event.stopPropagation()" class="clone-selection">
                      <mat-form-field>
                        <mat-label>{{'Clone Permissions From' | translate}}</mat-label>
                        <mat-select [(ngModel)]="cloneSources[role.id]" (selectionChange)="clonePermissions(role, $event.value)">
                          <mat-option [value]="null">{{'None' | translate}}</mat-option>
                          @for (existingRole of roles; track trackById($index, existingRole)) {
                            @if (!!existingRole.id) {
                              <mat-option [value]="existingRole.id">
                                {{ existingRole.name }}
                              </mat-option>
                            }
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                  }
                  <div class="button-group">
                    @if (isEditingRole[role.id]) {
                      <button class="btn modal-footer-btn save-modal-btn" [disabled]="isDisabled(role)" (click)="saveRole(role); $event.stopPropagation();">
                        {{'Save' | translate}}
                      </button>
                    }
                    @if (isEditingRole[role.id]) {
                      <button class="btn modal-footer-btn cancel-modal-btn" (click)="cancelEdit(role); $event.stopPropagation();">
                        {{'Cancel' | translate}}
                      </button>
                    }
                    @if (!isEditingRole[role.id]) {
                      <button mat-button (click)="editRole(role); $event.stopPropagation();">
                        <i class="fa fa-edit"></i> {{'Edit' | translate}}
                      </button>
                    }
                  </div>
                </mat-expansion-panel-header>
                <table mat-table [dataSource]="role.rolePermissions" class="mat-elevation-z8">
                  <ng-container matColumnDef="module">
                    <th mat-header-cell *matHeaderCellDef> {{'Module' | translate}} </th>
                    <td mat-cell *matCellDef="let perm"> {{ perm.objectId | mapLookup: objectNamesById : perm.objectId | translate }} </td>
                  </ng-container>
                  @for (flag of permissionsList; track trackByIndex(i); let i = $index) {
                    <ng-container [matColumnDef]="permissionNames[i]">
                      <th mat-header-cell *matHeaderCellDef>
                  <i class="fa mr-1" [ngClass]="{
                    'fa-folder-open': permissionNames[i] === 'Read',
                    'fa-pencil-alt': permissionNames[i] === 'Create/Update',
                    'fa-trash': permissionNames[i] === 'Delete',
                    'fa-user-shield': permissionNames[i] === 'Admin'
                  }"></i> {{ permissionNames[i] | translate }}
                      </th>
                      <td mat-cell *matCellDef="let perm"
                        [matTooltip]="(perm.objectId === piiObjectId && flag !== readFlag) ? ('View-only permission' | translate) : ''">
                        <mat-checkbox color="primary"
                          [checked]="hasPermission(perm, flag)"
                          (change)="togglePermission(perm, flag)"
                          [disabled]="!isEditingRole[role.id] || isPermissionDisabled(perm, flag)"
                          class="primary">
                        </mat-checkbox>
                      </td>
                    </ng-container>
                  }
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
              </mat-expansion-panel>
            }
          </mat-accordion>

          <div class="clearfix"></div>
        </div>
      </section>
    </app-sidebar-layout>
  </div>